import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import Pagination from "react-js-pagination";
import { getLoginInfo, setSearchInfo } from '../utils/storage';
import { createNotification } from './Popup';
import AppManagementReusComponent from '../hooks/useApplicationManagement';
const ApplicationsTableComponent = ({
  applicationsData,
  updateApplicationTable,
}) => {
  // remSessionNextPage();
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [applications, setApplications] = useState([]);

  const navigate = useNavigate();
  const [etd, setEtd] = useState({});
  const [error, seterror] = useState();
  const [loading, setLoading] = useState([]);

  const ref = useRef(null);

  const styles = {
    h4: {
      color: "#850505",
      textTransform: "uppercase",
    },
    h4Unlock: {
      color: "green",
      textTransform: "uppercase",
    },
  };

  const [show, setShow] = useState(false);

  const AdminPerPage = 3;
  const [activePage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const releaseApplication = async (applicationID) => {
    const payload = {
      ApplicationId: applicationID,
      OperationType: "UNTAKE",
      Action: "",
      StageId: "",
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
    };

    const result = await handleApplicationManagement(
      payload,
      "pull_management",
    );
    if (result.code == 1) {
      updateApplicationTable();
      const info = { type: "success", message: result.message };
      createNotification(info)();
    } else {
      const info = { type: "error", message: result.message };
      createNotification(info)();
    }
  };

  const viewApplicationsDetails = async (applicationID, index) => {
    setLoading((prev) => {
      const newLoadingState = [...prev]; // Copy the previous state
      newLoadingState[index] = true; // Set the loading state for this index
      return newLoadingState; // Return the updated state
    });

    const payload = {
      ApplicationId: applicationID,
      UserName: getLoginInfo()?.user?.Username,
      StageId: 510,
      Station: getLoginInfo()?.user?.StationID,
      Action: "View",
      AccessorId: getLoginInfo()?.user?.UserID,
    };

    try {
      const result = await handleApplicationManagement(
        payload,
        "application_management",
      );

      setLoading((prev) => {
        const newLoadingState = [...prev]; // Copy the previous state again
        newLoadingState[index] = false; // Reset the loading state
        return newLoadingState; // Return the updated state
      });

      if (result?.code == 1) {
        const response = {
          data: result.data,
          pageFrom: "Assessment",
        };
        setSearchInfo(response);
        navigate("/viewDetails");
      } else {
        setApplications(null);
        const info = { type: "error", message: result?.message };
        createNotification(info)();
      }
    } catch (error) {
      console.error("Error handling application:", error);

      // Ensure loading is set to false in case of an error
      setLoading((prev) => {
        const newLoadingState = [...prev];
        newLoadingState[index] = false;
        return newLoadingState;
      });
    }
  };

  return (
    <div className="col-md-12">
      <div className="card2">
        <div className="card-body">
          <div className="container">
            {error && (
              <p style={{ color: "red" }}>
                <center>{error}</center>
              </p>
            )}
            <table
              // id="example"
              id="myTable"
              className="table table-striped table-bordered"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>
                    <b>ApplicationID</b>
                  </th>
                  <th style={{ width: "27%" }}>
                    <b>Full Name</b>
                  </th>

                  <th style={{ width: "13%" }}>
                    <b>Application Type</b>
                  </th>
                  <th style={{ width: "10%" }}>
                    <b>Status</b>
                  </th>
                  <th style={{ width: "20%" }}>
                    <b>Action</b>
                  </th>
                </tr>
              </thead>
              {applicationsData?.length > 0 ? (
                <tbody>
                  {applicationsData?.map((obj, index) => (
                    <tr>
                      <td>
                        <h4 style={styles.h4}>{obj?.ApplicationID}</h4>
                      </td>
                      <td>
                        <h4 style={styles.h4}>{obj?.FullName}</h4>
                      </td>

                      <td>
                        <h4 style={styles.h4}>{obj?.ApplicationFromName}</h4>
                      </td>

                      {obj?.IsLocked ? (
                        <td>
                          <h4 style={styles.h4}>Locked</h4>
                        </td>
                      ) : (
                        <td>
                          <h4 style={styles.h4Unlock}>Unlock</h4>
                        </td>
                      )}

                      <td>
                        <button
                          type="submit"
                          className="btn btn btn btn-primary btn-sm"
                          name="ViewPass"
                          value="0002033"
                          onClick={() =>
                            viewApplicationsDetails(obj?.ApplicationID, index)
                          }
                        >
                          {loading[index] ? "Wait.." : "View"}
                        </button>
                        <button
                          type="submit"
                          className="btn btn btn btn-danger btn-sm"
                          name="ViewPass"
                          value="0002033"
                          onClick={() => releaseApplication(obj?.ApplicationID)}
                        >
                          Release
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={5}>
                      <h4 style={{ color: "red" }}>No applications</h4>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
            <div className="pagination pull-left">
              <i style={{ color: "grey" }}>Page: {activePage}</i>
            </div>
            <div className="pagination pull-right">
              <Pagination
                activePage={activePage}
                itemsCountPerPage={3}
                totalItemsCount={applications.length}
                pageRangeDisplayed={3}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ApplicationsTableComponent;
